import { Quote } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

export const ProofStrip = () => (
  <section id="proof" data-testid="proof" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-20 sm:py-24">
    <SectionTag index="01" label="Customer Results" center />
    <Reveal className="mx-auto mt-10 max-w-3xl">
      <div className="relative rounded-3xl border border-ink/10 bg-surface p-10 text-center shadow-xl sm:p-12">
        <Quote size={40} className="mx-auto text-mint/40" />
        <blockquote className="mt-6 font-display text-xl font-medium leading-relaxed text-white/90 sm:text-2xl" data-testid="proof-quote">
          "We are so glad we made the switch to CardConnect... Not only has it saved us money in
          monthly credit card fees, but it has improved our front desk's efficiency as well."
        </blockquote>
        <footer className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-mint">
          — Living Well Chiropractic
        </footer>
        <p className="mt-6 text-[11px] leading-relaxed text-white/35">
          A real CardConnect Commerce customer. Results vary by business — your free review
          determines what's possible for you.
        </p>
      </div>
    </Reveal>
  </section>
);
